import { ReactNode } from "react";

interface AnimatedGradientTextProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export const AnimatedGradientText = ({ 
  children, 
  className = "",
  delay = 1800
}: AnimatedGradientTextProps) => {
  return (
    <div
      className={`${className} animate-gradient-text`}
      style={{
        background: 'linear-gradient(90deg, hsl(var(--primary)), hsl(var(--accent)), hsl(var(--primary)))',
        backgroundSize: '200% auto',
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        animation: 'gradient-shift 4s ease infinite, fade-in 0.8s ease-out forwards',
        animationDelay: `${delay}ms, ${delay}ms`,
        opacity: 0,
        willChange: 'background-position, opacity'
      }}
    >
      {children}
    </div>
  );
};
